module.exports = __webpack_public_path__ + "static/media/7640fcc8f0cc3f559bf01152805ab018 copy.99a1aa46.png";